import { Avatar, Box, Stack, Typography } from '@mui/material';

function UserInfo() {
  return (
    <Box sx={StyleSheet.container}>
      <Avatar sx={StyleSheet.userPicture} />

      <Stack sx={StyleSheet.userInfoWrapper} direction="column">
        <Typography>Jhon Smith</Typography>
        <Typography className="jobTitle">Delivery Director</Typography>
      </Stack>
    </Box>
  );
};

const StyleSheet = {
  container: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    margin: '20px 24px 0px 24px',
    marginLeft: '24px',
    background: theme.palette.grey[60],
    borderRadius: '2px',
    padding: '8px',
    '& .MuiTypography-root': {
      fontFamily: 'Inter',
      color: theme.palette.common.white,
      fontWeight: 500,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '&.jobTitle': {
        fontSize: '12px',
        color: theme.palette.grey[40],
      },

    },
  }),
  userInfoWrapper: {
    width: '113px',
  },
  userPicture: {
    marginRight: '10px',
  },
};


export default UserInfo;
